import { render, staticRenderFns } from "./SkeletonWeb.vue?vue&type=template&id=522377d2&scoped=true"
import script from "./SkeletonWeb.vue?vue&type=script&lang=js"
export * from "./SkeletonWeb.vue?vue&type=script&lang=js"
import style0 from "./SkeletonWeb.vue?vue&type=style&index=0&id=522377d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522377d2",
  null
  
)

export default component.exports